import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { clearLocalStorageSession } from "../../lib/authUtils";
import { logoutApi } from "../../lib/sessionClient";
import ErrorBounce from "../portal/ErrorBounce";

const LogoutAction = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogout = async () => {
    setLoading(true);
    try {
      await logoutApi();
      clearLocalStorageSession();
      navigate("/login");
    } catch (err) {
      if (err.response?.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong";
        setError(message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {children({
        onLogout: handleLogout,
        loading,
      })}
      {error && (
        <ErrorBounce onClose={() => setError(null)}>
          <p className="text-red-500">
            <span className="font-bold">ERROR:</span> {error}{" "}
          </p>
        </ErrorBounce>
      )}
    </>
  );
};

export default LogoutAction;
